<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { mdiCheckAll, mdiPlusCircleOutline } from "@mdi/js"
  import type {
    ContactOrderAppointmentRow,
    ContactOrderPostalToggleOption,
    RowCommunicationSelection,
  } from "../../../../../../_logic/planning-selection-contract"
  import {
    postalRecipientPresentation,
    postalTimingPresentation,
  } from "../../../../_shared/_logic/postal-presentation"
  import { postalSelectionValue } from "../../../../../../_logic/channels"

  let {
    selection,
    active,
    preview,
    options,
    objectAddressLines,
    disabled,
    pending,
    planningPreviewError = null,
    onToggle,
  }: {
    selection: RowCommunicationSelection["postal"]
    active: boolean
    preview?: ContactOrderAppointmentRow["planningPreview"]
    options: ContactOrderPostalToggleOption[]
    objectAddressLines: string[]
    disabled: boolean
    pending: boolean
    planningPreviewError?: string | null
    onToggle: () => void
  } = $props()
  const recipient = $derived(postalRecipientPresentation(selection, preview))
  const option = $derived(
    options.find((option) => option.value === postalSelectionValue(selection)),
  )
  const label = $derived(
    selection.mode === "NOTICE"
      ? "Aushang"
      : selection.mode === "IMPERSONAL"
        ? "Brief an Objektadresse"
        : recipient.name || "Briefempfänger wählen",
  )
  const street = $derived(
    recipient.address
      ? `${recipient.address.street} ${recipient.address.house_number}`
      : selection.mode !== "PERSONAL"
        ? (objectAddressLines[0] ?? "")
        : "Adresse bitte prüfen",
  )
  const unavailableReason = $derived(
    selection.mode === "DISABLED"
      ? "Bitte zuerst einen Briefempfänger auswählen."
      : option?.disabled
        ? option.tooltip || "Briefempfänger ist nicht verfügbar."
        : selection.dispatch_mode === "AUTOMATIC" && !preview?.automatic_postal_available
          ? preview?.automatic_postal_disabled_reason ||
            "Automatische Zustellung ist nicht verfügbar."
          : null,
  )
  const timing = $derived(
    postalTimingPresentation({
      selection,
      preview,
      active,
      pending,
      previewError: planningPreviewError,
      unavailableReason,
    }),
  )
</script>

<button
  type="button"
  class="postal-tag"
  aria-label={selection.mode === "NOTICE" ? "Aushang einplanen" : `Terminbrief an ${label}`}
  aria-pressed={active}
  disabled={disabled || pending || (!active && Boolean(unavailableReason))}
  onclick={(event) => {
    event.stopPropagation()
    onToggle()
  }}
>
  <StatusTag
    variant="status"
    size="sm"
    {label}
    topLabel={timing.topLabel}
    subLabel={street}
    color={timing.color}
    icon={active ? mdiCheckAll : mdiPlusCircleOutline}
    tooltipContent={unavailableReason ?? undefined}
    disableTitle={true}
  />
</button>

<style>
  .postal-tag {
    display: inline-flex;
    min-width: 0;
    max-width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    font: inherit;
    cursor: pointer;
  }
  .postal-tag:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
</style>
